// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BuildTwoToneSvg from "@ant-design/icons-svg/es/asn/BuildTwoTone";
import AntdIcon from '../components/AntdIcon';

var BuildTwoTone = function BuildTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BuildTwoToneSvg
  }));
};

BuildTwoTone.displayName = 'BuildTwoTone';
export default React.forwardRef(BuildTwoTone);